
// // src/Components/Report/CustomHooks/useProfitLossReport.js
// import { useState, useEffect } from "react";
// import axios from "axios";
// import config from "../../../Helpers/config.json";

// export const useProfitLossReport = () => {
//   const today = new Date().toISOString().split("T")[0];

//   const [report, setReport] = useState({
//     summary: {},
//     retail_summary: {},
//     wholesale_summary: {},
//     sales_details: [],
//     pagination: {}
//   });

//   const [loading, setLoading] = useState(true);
//   const [from_date, setFromDate] = useState(today);
//   const [to_date, setToDate] = useState(today);
//   const [search, setSearch] = useState("");
//   const [page, setPage] = useState(1);
//   const [hasMore, setHasMore] = useState(true);

//   const per_page = 1000;

//   const fetchReport = async (reset = false) => {
//     if (!from_date || !to_date) return;

//     const currentPage = reset ? 1 : page;
//     setLoading(true);

//     try {
//       const res = await axios.get(`${config.epharmUrl}/Creport/general-profit-loss`, {
//         params: {
//           start_date: from_date,
//           end_date: to_date,
//           search: search || undefined,
//           page: currentPage,
//           per_page,
//         },
//       });

//       const data = res.data;

//       setReport(prev => ({
//         summary: data.summary || {},
//         retail_summary: data.retail_summary || {},      // ← NEW
//         wholesale_summary: data.wholesale_summary || {}, // ← NEW
//         sales_details: reset 
//           ? data.sales_details || [] 
//           : [...prev.sales_details, ...(data.sales_details || [])],
//         pagination: data.pagination || {}
//       }));

//       setHasMore(data.pagination?.has_next || false);
//       if (reset) {
//         setPage(2);
//       } else {
//         setPage(prev => prev + 1);
//       }
//     } catch (err) {
//       console.error("Error fetching profit/loss report:", err);
//     } finally {
//       setLoading(false);
//     }
//   };

//   // Initial load
//   useEffect(() => {
//     fetchReport(true);
//     // eslint-disable-next-line
//   }, []);

//   // Refetch on filters change (debounced)
//   useEffect(() => {
//     const timer = setTimeout(() => {
//       fetchReport(true);
//     }, 600);

//     return () => clearTimeout(timer);
//     // eslint-disable-next-line
//   }, [from_date, to_date, search]);

//   const loadMore = () => {
//     if (!loading && hasMore) {
//       fetchReport();
//     }
//   };

//   const handleChangeDate = (e) => {
//     const { name, value } = e.target;
//     if (name === "from_date") setFromDate(value);
//     if (name === "to_date") setToDate(value);
//   };

//   return {
//     loading,
//     report,
//     from_date,
//     to_date,
//     search,
//     setSearch,
//     handleChangeDate,
//     loadMore,
//     hasMore,
//     per_page,
//   };
// };
// src/Components/Report/CustomHooks/useProfitLossReport.js
// src/Components/Report/CustomHooks/useProfitLossReport.js
import { useState, useEffect } from "react";
import axios from "axios";
import config from "../../../Helpers/config.json";

export const useProfitLossReport = () => {
  const today = new Date().toISOString().split("T")[0];

  const [report, setReport] = useState({
    summary: {},
    retail_summary: {},
    wholesale_summary: {},
    sales_details: [],
    pagination: {}
  });

  const [loading, setLoading] = useState(true);
  const [from_date, setFromDate] = useState(today);
  const [to_date, setToDate] = useState(today);
  const [search, setSearch] = useState("");
  const [selectedSalesPerson, setSelectedSalesPerson] = useState("");

  // New: Sales Persons List
  const [salesPersons, setSalesPersons] = useState([]);
  const [salesPersonsLoading, setSalesPersonsLoading] = useState(false);

  const [page, setPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);

  const per_page = 1000;

  // Fetch Sales Persons
  const fetchSalesPersons = async () => {
    setSalesPersonsLoading(true);
    try {
      const res = await axios.get(`${config.epharmUrl}/admin/get_users_with_roles`);
      const data = res.data || [];
      
      const formatted = data.map(person => ({
        value: person.user_id,
        label: `${person.first_name || ''} ${person.last_name || ''}`.trim() || person.email,
      }));

      setSalesPersons(formatted);
    } catch (err) {
      console.error("Failed to fetch sales persons:", err);
      setSalesPersons([]);
    } finally {
      setSalesPersonsLoading(false);
    }
  };

  // Fetch Report Data
  const fetchReport = async (reset = false) => {
    if (!from_date || !to_date) return;

    const currentPage = reset ? 1 : page;
    setLoading(true);

    try {
      const res = await axios.get(`${config.epharmUrl}/Creport/general-profit-loss`, {
        params: {
          start_date: from_date,
          end_date: to_date,
          search: search || undefined,
          user_id: selectedSalesPerson || undefined,
          page: currentPage,
          per_page,
        },
      });

      const data = res.data;

      setReport(prev => ({
        summary: data.summary || {},
        retail_summary: data.retail_summary || {},
        wholesale_summary: data.wholesale_summary || {},
        sales_details: reset 
          ? (data.sales_details || []) 
          : [...prev.sales_details, ...(data.sales_details || [])],
        pagination: data.pagination || {}
      }));

      setHasMore(data.pagination?.has_next || false);

      if (reset) {
        setPage(2);
      } else {
        setPage(prev => prev + 1);
      }
    } catch (err) {
      console.error("Error fetching profit/loss report:", err);
    } finally {
      setLoading(false);
    }
  };

  // Fetch Sales Persons on mount
  useEffect(() => {
    fetchSalesPersons();
  }, []);

  // Initial Report Load
  useEffect(() => {
    fetchReport(true);
    // eslint-disable-next-line
  }, []);

  // Refetch report when filters change
  useEffect(() => {
    const timer = setTimeout(() => {
      fetchReport(true);
    }, 500);

    return () => clearTimeout(timer);
    // eslint-disable-next-line
  }, [from_date, to_date, search, selectedSalesPerson]);

  const loadMore = () => {
    if (!loading && hasMore) {
      fetchReport(false);
    }
  };

  const handleChangeDate = (e) => {
    const { name, value } = e.target;
    if (name === "from_date") setFromDate(value);
    if (name === "to_date") setToDate(value);
  };

  return {
    loading,
    report,
    from_date,
    to_date,
    search,
    setSearch,
    selectedSalesPerson,
    setSelectedSalesPerson,
    salesPersons,           // ← Added
    salesPersonsLoading,    // ← Added (optional)
    handleChangeDate,
    loadMore,
    hasMore,
    per_page,
  };
};